import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '@progress/kendo-data-query/dist/npm/state';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { UserMultiSelectorModel } from '../../models/user-multi-selector.model';
import { LocationUsersDropDownModel } from '../../models/users-drop-down-list.model';

@Component({
  selector: 'app-user-multi-selector',
  templateUrl: './user-multi-selector.component.html',
  styleUrls: ['./user-multi-selector.component.scss']
})
export class UserMultiSelectorComponent implements OnInit {

  //public checkedLocationIds: number[] = [-1];
  //public userLocationIds: number[] = [-1];
  public expandedKeys: any[] = ["-1"];
  public selectorOpened: boolean = false;
  @Input() selectedUserName: string = "Select";
  @Input() selectedUserId: number = 0;
  @Input() searchKeyWord: string = '';

  @Input() isIncludeFloatLocation: boolean = true;
  @Input() hideBranchLess: boolean = false;
  @Input() isDisableParentClick: boolean = false;
  @Input() dispatchStateEvent: boolean = true;
  @Output() onChange: EventEmitter<UserMultiSelectorModel[]> = new EventEmitter();


  @Input() page: string = "";
  @Input()
  public checkedKeys: number[] = [];
  @Input() selectorDisabled: boolean = false;
  selectedUsers: UserMultiSelectorModel[] = [];
  public locations: UserMultiSelectorModel[] = [];

  constructor(private locationService: LocationService,
    private elementRef: ElementRef,
    private store: Store<State>,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.locationService.getNestedLocationUserHierarchy()
      .subscribe((response: LocationUsersDropDownModel[]) => {
        this.locations = this.getLocations(response);
        this.setDefaultValue(this.checkedKeys, this.locations);
      });
  }

  private getLocations(items?: LocationUsersDropDownModel[]): UserMultiSelectorModel[] {
    if (!items) return [];

    const locations: UserMultiSelectorModel[] = [];
    for (const item of items) {
      locations.push({
        name: item.name,
        id: item.id,
        locationId: item.locationId,
        isUser: item.isUser,
        hasChild: item.hasChild,
        items: this.getLocations(item.items),
        isSelected: false,
        isSelectable: item.isUser
      });
    }
    return locations;
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.selectorOpened = false;
    }
  }

  public closeDropDown() {
    this.selectorOpened = false;

  }

  public onItemSelected(data: LocationUsersDropDownModel) {
    this.selectorOpened = false;
  }

  /**
 * Recursively sets default selected users based on given keys.
 * @param checkedKeys - Array of IDs to be pre-selected.
 * @param items - Array of UserMultiSelectorModel objects to search in.
 * Updates `selectedUsers` to include UserMultiSelectorModel objects with matching IDs.
 */
  public setDefaultValue(checkedKeys: number[], items?: UserMultiSelectorModel[]) {
    if (!items) return;
    for (const item of items) {
      if (item.id && checkedKeys.includes(item.id)) {
        if (item.isUser) {
          this.selectedUsers.push(item);
        }
      }
      else {
        this.setDefaultValue(checkedKeys, item.items)
      }
    }
  }

  public handleChildCheck(childItems?: UserMultiSelectorModel[]) {
    if (!childItems) return;
    for (const childItem of childItems) {
      if (childItem.isUser) {
        this.selectedUsers.push(childItem);
        this.handleChildCheck(childItem.items);
      }
    }
  }

  private addExpandListItem(treeItem: LocationUsersDropDownModel[]) {
    treeItem.forEach(item => {

      if (item.items && item.items.length > 0) {
        this.expandedKeys.push(item.id);
        this.addExpandListItem(item.items)
      }
    });
  }

  public handleChange(data: number[]) {
    this.checkedKeys = data;
    this.selectedUsers = [];
    this.addSelectedUsers(data, this.locations);
    this.onChange.emit(this.selectedUsers);
  }

  /**
 * Recursively adds selected users to `selectedUsers` based on their IDs.
 * @param data - Array of user IDs to be selected.
 * @param childItems - Array of UserMultiSelectorModel objects to search in.
 * Updates `selectedUsers` to include UserMultiSelectorModel objects with matching IDs.
 */
  private addSelectedUsers(data: number[], childItems?: UserMultiSelectorModel[]) {
    if (!childItems) return;
    for (const childItem of childItems) {
      if (childItem.isUser && childItem.id && data.includes(childItem.id)) {
        this.selectedUsers.push(childItem);
      }
      if (childItem.hasChild) {
        this.addSelectedUsers(data, childItem.items);
      }
    }
  }

  public locationClick() {
    this.selectorOpened = !this.selectorOpened;
  }

  public chips = [
    {
      label: "Apple",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-delete",
    },
    {
      label: "Strawberry",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-cancel-circle",
    },
    {
      label: "Banana",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-close-outline",
    },
    {
      label: "Kiwi",
      selected: false,
      removable: true,
      removeIcon: "k-icon k-i-close",
    },
  ];

  public onRemove(item: LocationUsersDropDownModel): void {
    const index = this.selectedUsers.findIndex((c) => c.id === item.id);
    const checkedKeyIndex = this.checkedKeys.findIndex(k => k == item.id);
    this.checkedKeys.splice(checkedKeyIndex, 1);
    this.selectedUsers.splice(index, 1);
    this.onChange.emit(this.selectedUsers);
  }

}
